import { makeStyles } from '@mui/styles';
import { Colors } from '../../../theme/colors';
import { TextFieldVariantProps } from '../text-field/text-field.component';

export const useDropdownStyles = makeStyles(() => ({
  dropdownIcon: {
    '& > .MuiSelect-icon': {
      top: 'calc(50% - 9px)',
      color: (props: TextFieldVariantProps) =>
        props.variant === 'floating' ? Colors.extraDarkGray : props.variant === 'primarySolid' ? '#000000' : '#FFFFFF'
    }
  },
  select: {
    '& > .MuiSelect-select:focus': {
      background: '#00000000'
    }
  },
  selectOptionIcon: {
    marginRight: '8px',
    color: Colors.midGray
  }
}));
